import { createAction } from 'redux-actions';

export const SET_ERROR = 'EXCHANGE/SET_ERROR';
export const CLEAR_ERROR = 'EXCHANGE/CLEAR_ERROR';

export const setError = createAction<string>(SET_ERROR);

export type SetErrorAction = ReturnType<typeof setError>;

export const clearError = createAction(CLEAR_ERROR);

export type ClearErrorAction = ReturnType<typeof clearError>;
